"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEdgeInstance = exports.isValidEdgeType = exports.isValidModelTypeId = exports.ModelClassList = exports.ModelClasses = exports.AggregationGroup = exports.Assembler = exports.BusinessObjectAssembler = exports.edgeTypeMatrix = exports.isClassDerivedDeviceEnabledType = exports.classDerivedDeviceEnabledTypes = exports.InvalidatedReason = exports.isEUIValid = exports.getDeviceEnabledTypesMap = void 0;
const tslib_1 = require("tslib");
const datamodel_core_1 = require("@iotv/datamodel-core");
Object.defineProperty(exports, "edgeTypeMatrix", { enumerable: true, get: function () { return datamodel_core_1.edgeTypeMatrix; } });
tslib_1.__exportStar(require("@iotv/datamodel-core"), exports);
var isDeviceEnabledType_1 = require("./Validation/isDeviceEnabledType");
Object.defineProperty(exports, "getDeviceEnabledTypesMap", { enumerable: true, get: function () { return isDeviceEnabledType_1.getDeviceEnabledTypesMap; } });
var isEUIValid_1 = require("./Validation/isEUIValid");
Object.defineProperty(exports, "isEUIValid", { enumerable: true, get: function () { return isEUIValid_1.isEUIValid; } });
var isValidEdgeType_1 = require("./Validation/isValidEdgeType");
Object.defineProperty(exports, "InvalidatedReason", { enumerable: true, get: function () { return isValidEdgeType_1.InvalidatedReason; } });
const debug = datamodel_core_1.DEBUG_OVERRIDE || (datamodel_core_1.NOT_LAMBDA && false);
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const AggregationGroupFactory_1 = require("./AggregationGroupFactory");
const datamodel_core_2 = require("@iotv/datamodel-core");
/** Sub Project imports REGEX MARKER GROUP - no empty lines in datamodel blocks */
/** v020 Datamodel */
const datamodel_1 = require("@v020/datamodel");
/** Sub Project imports REGEX MARKER GROUP - exit */
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const getUserAttributes_1 = require("./ClassMutation/getUserAttributes");
const isDeviceEnabledType_2 = require("./Validation/isDeviceEnabledType");
const isGenericClass_1 = require("./Validation/isGenericClass");
const isValidEdgeType_2 = require("./Validation/isValidEdgeType");
/** ModelClasses REGEX MARKER GROUP - no empty lines */
const ModelClasses = Object.assign({}, datamodel_core_2.ModelClasses, datamodel_1.ModelClasses);
exports.ModelClasses = ModelClasses;
/** ModelClassNames REGEX MARKER GROUP - exit */
/** List of names of Model classes that extend `DeviceEnabledType` --- this does not garauntee that the class has been exposed as deviceEnabledType in `@iotv/payload-definition` */
const classDerivedDeviceEnabledTypes = Object.entries((0, isDeviceEnabledType_2.getDeviceEnabledTypesMap)(ModelClasses))
    .filter(([k, v]) => v === true)
    .map(([k]) => k);
exports.classDerivedDeviceEnabledTypes = classDerivedDeviceEnabledTypes;
/** Prune generic classes */
if (config_1.default.apps?.webUI?.pruneGenericEntities) {
    // prune all
    for (const GenericEntityClassName of datamodel_core_1.GenericEntityClassNames) {
        const idx = classDerivedDeviceEnabledTypes.findIndex((className) => className === GenericEntityClassName);
        classDerivedDeviceEnabledTypes.splice(idx, 1);
    }
}
else {
    const classMap = Object.fromEntries(Object.entries(ModelClasses));
    for (const GenericEntityClassName of datamodel_core_1.GenericEntityClassNames) {
        const [genericClass, genericClassInstance] = (0, isGenericClass_1.instantiate)(classMap, GenericEntityClassName);
        if (genericClassInstance === undefined)
            continue;
        const isGeneric = genericClassInstance instanceof genericClass;
        // if the check (above) failed, something is terribly wrong and we can't reasonably expect to to the following checks accurately
        if (!isGeneric)
            continue;
        for (const modelClassName in classMap) {
            // don't prune the generic classes, as they are always instances of themselves!
            if (modelClassName === GenericEntityClassName)
                continue;
            const [modelClass, modelClassInstance] = (0, isGenericClass_1.instantiate)(classMap, modelClassName);
            const isExtends = modelClassInstance instanceof genericClass;
            if (!isExtends)
                continue;
            // if there is even one class that extends from this generic class, prune the generic class
            const idx = classDerivedDeviceEnabledTypes.findIndex((className) => className === GenericEntityClassName);
            if (idx === -1)
                continue;
            classDerivedDeviceEnabledTypes.splice(idx, 1);
            break;
        }
    }
}
/** matrixes REGEX MARKER GROUP - no empty lines */
const matrixes = [datamodel_1.edgeTypeMatrix];
/** Alternative to isDeviceEnabled type from @iotv/payload-definition, to be used where module dependencies mean no acccess to the original fn */
const isClassDerivedDeviceEnabledType = (item) => classDerivedDeviceEnabledTypes.includes(item.type);
exports.isClassDerivedDeviceEnabledType = isClassDerivedDeviceEnabledType;
/**
 * Extend `Group` user attributes with the configured domains
 *
 * Also extend `Device`-supporting `Group`'s with a `subSupportedType` for the device type
 *
 * NOTE: Only use inline functions, not arrow-functions, in order to preserve `this`!
 */
if (0 < Object.keys(config_1.default.app.webUI.domainMap).length) {
    const enumKv = Object.fromEntries(Object.keys(config_1.default.app.webUI.domainMap).map((k) => [k, k]));
    (0, getUserAttributes_1.mutateGetUserAttributes)({
        clazz: datamodel_core_1.Group,
        override: {},
        extend: {
            getUserAttributes: function () {
                const groupThis = this;
                const enableDomains = classDerivedDeviceEnabledTypes.includes(groupThis.supportedType ?? '') || groupThis.supportedType === 'Device';
                const domainExtension = enableDomains ? { domain: { type: 'Enum', editable: true, enumKv, required: true } } : {};
                const deviceGroupExtensions = groupThis?.supportedType === 'Device'
                    ? {
                        subSupportedType: {
                            type: 'Enum',
                            label: 'Device Type',
                            editable: true,
                            required: true,
                            enumKv: Object.fromEntries(Object.entries(iotv_v3_types_1.DeviceTypes)
                                .filter(([k, v]) => !isNaN(parseInt(v)))
                                .map(([k, v]) => [iotv_v3_types_1.DeviceTypeNames[v], v])),
                        },
                    }
                    : {};
                return {
                    ...domainExtension,
                    ...deviceGroupExtensions,
                };
            },
        },
    });
}
/**
 * RSE 2024 03 Note: EdgeTypeMatrix Mutation
 * this mutates the edgeTypeMatix exported from @iotv/datamodel-core for all consumers
 * file:///./../../datamodel-core/src/classDependentTypes/EdgeTypes/edgeTypeMatrixFns.ts
 * ie non-core, external project edgeTypes are included. As observered in UI Listerlizer where an import from @iotv/datamodel-core of getParentEdgeTypeId correctly
 * resolves external project edges.
 *
 * Look here if unwanted side effects are seen in the future.
 * Resolution is to move edge validation function to this module.
 */
const etm = datamodel_core_1.edgeTypeMatrix;
try {
    matrixes.forEach((matrix) => {
        Object.entries(matrix).forEach(([sourceType, targetTypeMap]) => {
            if (etm[sourceType]) {
                Object.entries(targetTypeMap).forEach(([targetType, edgeTypeDefMap]) => {
                    if (etm[sourceType][targetType]) {
                        Object.assign(etm[sourceType][targetType], edgeTypeDefMap);
                    }
                    else {
                        etm[sourceType][targetType] = edgeTypeDefMap;
                    }
                });
            }
            else {
                etm[sourceType] = targetTypeMap;
            }
        });
    });
}
catch (e) {
    console.log('Error merging edgeMatrix', e.message);
}
/** check for deviceEnabledTypes presence in edgeTypeMatrix */
classDerivedDeviceEnabledTypes.forEach((objectTypeId) => {
    // add entry for deviceEnabledType if not present
    if (!etm[objectTypeId]) {
        debug && console.log(`No edgeTypeMatrix entry for deviceEnabledType ${objectTypeId}`);
        const newDeviceEdgeEntry = (0, datamodel_core_1.getEntityToDeviceEdgeTypeMatrixEntry)(objectTypeId);
        const newPlaceEdgeEntry = (0, datamodel_core_1.getEntityToPlaceEdgeTypeMatrixEntry)(objectTypeId);
        const newScoreEdgeEntry = (0, datamodel_core_1.getEntityToScoreConfigEdgeTypeMatrixEntry)(objectTypeId);
        const newEntry = { ...newDeviceEdgeEntry, ...newPlaceEdgeEntry, ...newScoreEdgeEntry };
        debug && console.log(`New Entry ${objectTypeId} `, { newDeviceEdgeEntry, newPlaceEdgeEntry, newScoreEdgeEntry, newEntry });
        etm[objectTypeId] = newEntry;
    }
    else {
        if (!etm[objectTypeId].Device) {
            etm[objectTypeId].Device = (0, datamodel_core_1.getEntityToDeviceEdgeTypeMatrixEntry)(objectTypeId).Place;
        }
        if (!etm[objectTypeId].Place) {
            etm[objectTypeId].Place = (0, datamodel_core_1.getEntityToPlaceEdgeTypeMatrixEntry)(objectTypeId).Place;
        }
    }
    // add Group to deviceEnabledType if not present
    if (!etm.Group[objectTypeId]) {
        const newEntry = (0, datamodel_core_1.getGroupToTypeEdgeTypeMatrixEntry)(objectTypeId);
        debug && console.log('New Group entry', newEntry);
        Object.assign(etm.Group, newEntry);
    }
    if (etm['EntityNetwork']['Entity'] && objectTypeId !== 'Entity')
        delete etm['EntityNetwork']['Entity'];
    if (!etm['EntityNetwork'][objectTypeId]) {
        etm['EntityNetwork'][objectTypeId] = (0, datamodel_core_1.getEntityNetworkToTypeEdgeTypeMatrixEntry)(objectTypeId)[objectTypeId];
    }
    if (config_1.default.apps?.webUI?.showProgrammeSets === true) {
        // add Programmes to deviceEnabledTypes, if not present
        if (!etm.EntityProgramme[objectTypeId]) {
            debug && console.log('EntityProgramme adding edgeTypeId to', objectTypeId);
            const newEntry = (0, datamodel_core_1.getEntityProgrammeToEntityEdgeTypeMatrixEntry)(objectTypeId);
            Object.assign(etm.EntityProgramme, newEntry);
        }
        if (!etm.EntityRollingProgramme[objectTypeId]) {
            debug && console.log('EntityRollingProgramme adding edgeTypeId to', objectTypeId);
            const newEntry = (0, datamodel_core_1.getEntityRollingProgrammeToEntityEdgeTypeMatrixEntry)(objectTypeId);
            // prior to 2025 06 10 this was wrongly assigned to EntityProgramme.
            // the effect would be that all EntityProgramme WaterCannon edges were typed as 'rolling_programme_schedules_WaterCannon' amd all rolling programme edge had undefined edgeTypeId
            //  Data checked OK in  v021 TEST, PROD with all instances showing correct value of 'programme_schedules_WaterCannon'
            // issue found when running file:///./../../../Utilities/src/Edges/correctEdgeTypes.ts
            Object.assign(etm.EntityRollingProgramme, newEntry);
        }
        if (!etm.OnDemandProgramme[objectTypeId]) {
            debug && console.log('OnDemandProgramme adding edgeTypeId to', objectTypeId);
            const newEntry = (0, datamodel_core_1.getOnDemandProgrammeToEntityEdgeTypeMatrixEntry)(objectTypeId);
            Object.assign(etm.OnDemandProgramme, newEntry);
        }
    }
});
Object.entries(etm).forEach(([sourceType, targetTypeMap]) => {
    if (classDerivedDeviceEnabledTypes.includes(sourceType)) {
        /** check for device relationship */
        if (!targetTypeMap.Device) {
            debug && console.log(`${sourceType} has no edgeType to device`);
            const newEntry = (0, datamodel_core_1.getEntityToDeviceEdgeTypeMatrixEntry)(sourceType);
            debug && console.log('New Entry', newEntry);
            Object.assign(etm[sourceType], newEntry);
        }
    }
});
const BusinessObjectAssembler = datamodel_core_2.BusinessObjectAssemblerFactory.createBusinessObjectAssembler(ModelClasses);
exports.BusinessObjectAssembler = BusinessObjectAssembler;
const Assembler = new BusinessObjectAssembler();
exports.Assembler = Assembler;
const AggregationGroup = (0, AggregationGroupFactory_1.AggregationGroupFactory)(ModelClasses);
exports.AggregationGroup = AggregationGroup;
const ModelClassList = Object.keys({ ...ModelClasses, AggregationGroup, System: datamodel_core_1.System });
exports.ModelClassList = ModelClassList;
function isClassLocal(value) {
    const isClass = typeof value === 'function' && !!value.prototype && !!value.prototype.constructor;
    if (!isClass) {
        console.log(`is not class`, value);
    }
    else {
        debug && console.log(`is class`, value);
    }
    return isClass;
}
/** WIP these will move to full datamodel definition in \@iotv/typed */
const isValidImportedModelClassNames = (ModelClassNames) => ModelClassNames instanceof Array && ModelClassNames.every((item) => typeof item === 'string');
const isValidModelClasses = (ModelClasses) => !!ModelClasses && typeof ModelClasses === 'object' && Object.entries(ModelClasses).every(([k, v]) => typeof k === 'string' && isClassLocal(v));
/* END OF VERY TEMP TYPE CHECK */
if (!isValidImportedModelClassNames(ModelClassList)) {
    throw new Error('INVALID ModelClassList');
}
if (!isValidModelClasses(ModelClasses)) {
    const invalidModelClassExports = {};
    Object.entries(ModelClasses).forEach(([k, v]) => {
        if (!(0, iotv_v3_types_1.isClass)(v)) {
            const hasProtoype = !!v.prototype;
            const hasConstructor = !!v.prototype?.constructor;
            const reason = `${k} is not a class. It is type ${typeof v}. ${hasProtoype ? '' : 'Has no prototype'}. ${hasConstructor ? '' : 'Has no prootype.constructor'}`;
            invalidModelClassExports[k] = reason;
        }
    });
    console.log(`Invalid exports found in @iotv/datamodel ModelClasses. The check that all exports are classes failed with:`, invalidModelClassExports);
    console.log(`If these are  enumerations or other constants, they should be moved external from /src/model, added to the src/index as exports and imported to the original location`);
    // throw new Error( 'INVALID ModelClasses')
}
const isValidModelTypeId = (objectTypeId) => ModelClassList.includes(objectTypeId);
exports.isValidModelTypeId = isValidModelTypeId;
exports.isValidEdgeType = (0, isValidEdgeType_2.isValidEdgeTypeFnFactory)({ businessObjectAssembler: new BusinessObjectAssembler(), edgeTypeMatrix: datamodel_core_1.edgeTypeMatrix });
const isValidEdgeInstance = ({ item }) => {
    let res = { isValid: false };
    if ((0, iotv_v3_types_1.isValidBusinessObject)(item) && (0, iotv_v3_types_1.isEdge)(item)) {
        const sourceObjectTypeId = item.pk.split(':')[0];
        const targetObjectTypeId = item.sk.split(':')[0];
        res = (0, exports.isValidEdgeType)({ sourceObjectTypeId, targetObjectTypeId });
    }
    else {
        res.reason = isValidEdgeType_2.InvalidatedReason.INVALID_TYPES;
        res.violation = `Item either not edge or not valid business object, ${JSON.stringify(item)}`;
    }
    return res;
};
exports.isValidEdgeInstance = isValidEdgeInstance;
